/**
 * Test IDs for QA automation.
 */
export const testIds = {
  groupSelectGroupsPicker: "group-select-groups-picker",
  groupSelectGroupsSearch: "group-select-groups-search",
} as const;
